<script setup>
const { isSignedIn } = useUser()
const storedService = useLocalStorage('tarc-auth-for-service')

watch([isSignedIn, storedService], async ([newIsSignedIn, newStoredService]) => {
  if (!newIsSignedIn || typeof newStoredService !== 'string') {
    return
  }

  try {
    if (newStoredService === 'The Show Portal') {
      await navigateTo('https://app.theshowportal.com', { external: true })
    }
  } catch (error) {
    console.error(error)
  } finally {
    storedService.value = null
  }
})
</script>

<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
